var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReducedComm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 67,
    viewBox: "0 0 66 67",
    width: 66,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "50%",
    cy: "0%",
    r: "84.880575%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#092176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092398"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: ".000014%",
    cy: "84.287402%",
    gradientTransform: "matrix(.27630452 -.3866587 .96107014 .11116311 -.810061 .749178)",
    r: "324.864217%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b515f3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436124505,
    stopColor: "#28fdca",
    stopOpacity: 0.863718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99dcff",
    stopOpacity: 0.277453
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: "69.60049%",
    cy: "9.565884%",
    gradientTransform: "matrix(.29849669 -.41771405 .95441067 .13064215 .396952 .373893)",
    r: "165.094611%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28fdca",
    stopOpacity: 0.863718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098712,
    stopColor: "#b515f3",
    stopOpacity: 0.524803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99dcff",
    stopOpacity: 0.277453
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: "19.352232%",
    cy: "78.281387%",
    gradientTransform: "matrix(.241113 -.33741174 .97049705 .08382752 -.612857 .782489)",
    r: "372.279599%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c124ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436124505,
    stopColor: "#3af4ec",
    stopOpacity: 0.581075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99dcff",
    stopOpacity: 0.277453
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70ffe8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "4.624277%",
    x2: "100%",
    xlinkHref: "#e",
    y1: "51.183681%",
    y2: "75.59709%"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "8.655592%",
    x2: "106.477248%",
    xlinkHref: "#e",
    y1: "52.312139%",
    y2: "76.477386%"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "8.05684%",
    x2: "96.217622%",
    xlinkHref: "#e",
    y1: "52.312139%",
    y2: "99.999999%"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "6.778122%",
    x2: "97.626655%",
    xlinkHref: "#e",
    y1: "52.312139%",
    y2: "99.999999%"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "8.172148%",
    x2: "96.090563%",
    xlinkHref: "#e",
    y1: "52.312139%",
    y2: "99.999999%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-11 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.090498,
    cy: 35.114423,
    fill: "url(#a)",
    r: 32.361991
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.470898 74.0866659c-8.3608367-5.4554904-14.091395-14.6922434-14.6538867-25.4252245-.2689096-5.1311008.6726143-10.0455773 2.5749035-14.466145 3.931034 2.1300352 8.4843866 3.7494133 9.445333 6.7457363 1.7362239 5.4137126-.7022466 5.0788353-5.5024017 9.5304393s-5.8657784 10.1782971 4.8473717 14.9471061c6.4478305 2.8701615 4.7435694 6.1459465 3.2886802 8.6680878z",
    fill: "url(#b)",
    opacity: 0.327567,
    transform: "matrix(.8660254 -.5 .5 .8660254 -23.480449 20.651733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.221836 66.070082c-3.83767-5.0088942-6.253598-11.1897503-6.6087901-17.9672186-.7774391-14.8344225 8.5623406-27.8582259 21.9861961-32.3709259-.3270129 4.7306048-2.5973495 3.867017-8.268572 6.3733457-5.9879362 2.6462967-8.8599318 7.7140584-.2830217 15.7109163 7.3878483 6.8882118-2.3981821 11.6986463-5.7410981 17.4887467-1.116618 1.9340391-1.4781887 5.5224177-1.084712 10.7651358z",
    fill: "url(#c)",
    opacity: 0.764974,
    transform: "matrix(.87461971 -.48480962 .48480962 .87461971 -16.997669 16.076911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.6735907 39.5377965c-3.5934087-2.7693661-6.5969346-6.2819157-8.7711892-10.3221024.9155711.9756217 2.451924 1.9449761 4.8291902 3.0532896 5.2138585 2.4307713 5.0079743 5.0364586 3.941999 7.2688128zm-9.8758172-12.5822018c-1.5420099-3.4953477-2.4866812-7.3248859-2.6984983-11.3665958-.2615969-4.9915676.6223026-9.77813243 2.4218497-14.10442134 3.5996824 2.27169058 6.7160414 5.16359498 5.0787654 11.27399214-2.0200056 7.5387635-5.102151 11.2937615-4.8021168 14.197025z",
    fill: "url(#d)",
    opacity: 0.43006,
    transform: "matrix(-.94551858 .32556815 -.32556815 -.94551858 136.383738 18.199563)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#f)",
    transform: "matrix(0 1 -1 0 53.58608 48.754578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.00732601 12.6336996h-5.26078784v-1.1428571h5.26078784v-2.4908425l2.93040293 2.9304029-2.93040293 2.930403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.00732601 3.63369963h-5.26078784v-1.14285714h5.26078784v-2.49084249l2.93040293 2.93040293-2.93040293 2.93040293z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 17)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.428571,
    cy: 19.021978,
    fill: "#92aadc",
    opacity: 0.26,
    r: 12.571429
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.428571,
    cy: 15.736264,
    fill: "#7077ce",
    opacity: 0.919643,
    rx: 12,
    ry: 12.571429
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.45055,
    fill: "url(#g)",
    rx: 12,
    ry: 12.571429
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#082292",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.6877098 28.4647414c0 .3581841-.0649199.6850221-.1947616.9805239s-.3022152.5495847-.5171256.7622565c-.2149103.2126718-.4645162.3772101-.7488247.4936199s-.5809251.1746138-.8898589.1746138c-.3402748 0-.6525619-.058204-.9368704-.1746138s-.5305564-.2809481-.7387508-.4936199-.3704941-.4667547-.486904-.7622565c-.1164098-.2955018-.1746138-.6223398-.1746138-.9805239 0-.3716159.058204-.7085277.1746138-1.0107454.1164099-.3022178.2787096-.560778.486904-.7756884s.4544423-.3816873.7387508-.5003358.5965956-.1779718.9368704-.1779718.6548004.0593233.9435863.1779718c.2887858.1186485.5372723.2854254.7454667.5003358.2081945.2149104.3704941.4734706.486904.7756884.1164098.3022177.1746138.6391295.1746138 1.0107454z",
    stroke: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.7635996 26.402955c.0671596-.0761141.1499884-.1466305.2484889-.2115514.0985007-.0649208.2350563-.0973808.409671-.0973808h1.5177971l-7.3740764 9.4895904c-.0671595.0850686-.1511077.155585-.2518469.2115513-.1007392.0559662-.2227438.083949-.3660175.083949h-1.5580926z",
    stroke: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.315648 33.58227c0 .358184-.0649198.6861413-.1947616.9838818-.1298417.2977405-.3022151.5529427-.5171256.7656145-.2149104.2126717-.4645161.37721-.7488247.4936199-.2843085.1164097-.5809252.1746138-.889859.1746138-.3402748 0-.6525617-.0582041-.9368703-.1746138-.2843085-.1164099-.5305564-.2809482-.7387509-.4936199-.2081944-.2126718-.3704941-.467874-.4869039-.7656145-.1164097-.2977405-.1746139-.6256978-.1746139-.9838818 0-.371616.0582042-.7085277.1746139-1.0107454.1164098-.3022179.2787095-.5607781.4869039-.7756885.2081945-.2149104.4544424-.3816873.7387509-.5003358.2843086-.1186484.5965955-.1779718.9368703-.1779718s.6548004.0593234.9435863.1779718c.2887859.1186485.5372723.2854254.7454668.5003358s.3704942.4734706.4869039.7756885c.1164099.3022177.1746139.6391294.1746139 1.0107454z",
    stroke: "url(#j)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.0893217 28.4647414c0-.2283423-.0190282-.4175054-.0570853-.5674949-.0380571-.1499896-.0906646-.2697556-.1578241-.3593016-.0671594-.089546-.1466304-.1522272-.238415-.1880456s-.1914031-.0537274-.2988583-.0537274c-.1074553 0-.2059543.017909-.2955003.0537274-.0895461.0358184-.165659.0984996-.2283412.1880456s-.1119318.209312-.1477502.3593016c-.0358184.1499895-.0537273.3391526-.0537273.5674949 0 .2149104.0179089.3939998.0537273.5372734s.085068.257443.1477502.3425117.1387951.1455114.2283412.1813298c.089546.0358184.188045.0537273.2955003.0537273.1074552 0 .2070737-.0179089.2988583-.0537273s.1712556-.0962611.238415-.1813298c.0671595-.0850687.119767-.1992381.1578241-.3425117s.0570853-.322363.0570853-.5372734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.7172598 33.58227c0-.2238651-.0190282-.4107896-.0570853-.560779-.038057-.1499896-.0906644-.2697557-.157824-.3593016-.0671595-.089546-.1466304-.1522274-.2384151-.1880456-.0917846-.0358184-.191403-.0537274-.2988583-.0537274-.1074551 0-.2059543.017909-.2955003.0537274-.0895459.0358182-.1656589.0984996-.2283412.1880456-.0626822.0895459-.1119317.209312-.1477501.3593016-.0358185.1499894-.0537274.3369139-.0537274.560779 0 .2149104.0179089.3939997.0537274.5372733.0358184.1432736.0850679.257443.1477501.3425118.0626823.0850687.1387953.1455113.2283412.1813297.089546.0358185.1880452.0537274.2955003.0537274.1074553 0 .2070737-.0179089.2988583-.0537274.0917847-.0358184.1712556-.096261.2384151-.1813297.0671596-.0850688.119767-.1992382.157824-.3425118.0380571-.1432736.0570853-.3223629.0570853-.5372733z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducedComm);
export default __webpack_public_path__ + "static/media/reduced-comm.38972e03d67b39fdea9fe3e9370a90f4.svg";
export { ForwardRef as ReactComponent };